var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEllipsisV(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 5.333c.733 0 1.333-.6 1.333-1.333S8.733 2.667 8 2.667 6.667 3.267 6.667 4 7.267 5.333 8 5.333zm0 1.334c-.733 0-1.333.6-1.333 1.333S7.267 9.333 8 9.333 9.333 8.733 9.333 8 8.733 6.667 8 6.667zm0 4c-.733 0-1.333.6-1.333 1.333s.6 1.333 1.333 1.333 1.333-.6 1.333-1.333-.6-1.333-1.333-1.333z",
    id: "ellipsis-v_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipsis-v_svg__c",
    d: "M0 0h33.333v33.333H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 -2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ellipsis-v_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ellipsis-v_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ellipsis-v_svg__b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#232323",
    xlinkHref: "#ellipsis-v_svg__c",
    transform: "translate(-8.667 -8.667)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ellipsis-v_svg__b)",
    fill: "#A6ADC6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-40-45.333H60v100H-40z"
  })))));
}

export default __webpack_public_path__ + "./fonts/ellipsis-v.9c7cfa78d7f57ba244c8a39206f4f52e.svg";
export { SvgEllipsisV as ReactComponent };